/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module for Alert related services and components
 * @module AlertModule
 * @preferred
 */

import angular from 'angular';

import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    ACTION_GROUP_CONFIG_COLLECTION_TOKEN,
    ACTION_GROUP_CONFIG_ITEM_TOKEN,
    ALERT_CONFIG_COLLECTION_TOKEN,
    ALERT_CONFIG_ITEM_TOKEN,
    ALERT_EMAIL_CONFIG_COLLECTION_TOKEN,
    ALERT_EMAIL_CONFIG_ITEM_TOKEN,
    ALERT_METRICS_COLLECTION_TOKEN,
    ALERT_METRICS_ITEM_TOKEN,
    SNMP_TRAP_PROFILE_COLLECTION_TOKEN,
    SNMP_TRAP_PROFILE_CONFIG_ITEM_TOKEN,
    SNMP_TRAP_SERVER_CONFIG_ITEM_TOKEN,
    SNMP_V3_USER_PARAMS_CONFIG_ITEM,
} from './alert.tokens';

import {
    ActionGroupConfigCollection,
    ActionGroupConfigItem,
    AlertConfigCollection,
    AlertConfigItem,
    AlertEmailConfigCollection,
    AlertEmailConfigItem,
    AlertMetricsCollection,
    AlertMetricsItem,
    SnmpTrapProfileCollection,
    SnmpTrapProfileItem,
    SnmpTrapServerConfigItem,
    SnmpV3UserParamsConfigItem,
} from './factories';

const alertModule = angular.module('avi/alert');

const factories = [
    {
        dependency: AlertEmailConfigItem,
        name: ALERT_EMAIL_CONFIG_ITEM_TOKEN,
    },
    {
        dependency: AlertEmailConfigCollection,
        name: ALERT_EMAIL_CONFIG_COLLECTION_TOKEN,
    },
    {
        dependency: SnmpTrapProfileItem,
        name: SNMP_TRAP_PROFILE_CONFIG_ITEM_TOKEN,
    },
    {
        dependency: SnmpTrapProfileCollection,
        name: SNMP_TRAP_PROFILE_COLLECTION_TOKEN,
    },
    {
        dependency: SnmpTrapServerConfigItem,
        name: SNMP_TRAP_SERVER_CONFIG_ITEM_TOKEN,
    },
    {
        dependency: SnmpV3UserParamsConfigItem,
        name: SNMP_V3_USER_PARAMS_CONFIG_ITEM,
    },
    {
        dependency: ActionGroupConfigCollection,
        name: ACTION_GROUP_CONFIG_COLLECTION_TOKEN,
    },
    {
        dependency: ActionGroupConfigItem,
        name: ACTION_GROUP_CONFIG_ITEM_TOKEN,
    },
    {
        dependency: AlertConfigCollection,
        name: ALERT_CONFIG_COLLECTION_TOKEN,
    },
    {
        dependency: AlertConfigItem,
        name: ALERT_CONFIG_ITEM_TOKEN,
    },
    {
        dependency: AlertMetricsCollection,
        name: ALERT_METRICS_COLLECTION_TOKEN,
    },
    {
        dependency: AlertMetricsItem,
        name: ALERT_METRICS_ITEM_TOKEN,
    },
];

factories.forEach(({ name, dependency }) => {
    initAjsDependency(
        alertModule,
        'factory',
        name,
        dependency,
    );
});
